export const REQUEST_SUGGEST = 'request_suggest' as const
export const SUCCESS_SUGGEST = 'success_suggest' as const
export const FAILURE_SUGGEST = 'failure_suggest' as const

export default {
  REQUEST_SUGGEST,
  SUCCESS_SUGGEST,
  FAILURE_SUGGEST
}
